import { CAT_AI_SEARCH } from 'App/utils/Collections';

// AI search has no constructor filters: its conditions live in AiSearchContextFilters (#add-conditions).
export default {
  category: CAT_AI_SEARCH,
  filters: [],
  searchBarProp: 'q',
};
